import React from "react"
import styled from "styled-components"
import { Icon } from "@components/icons"
import { Link } from "gatsby"

const StyledProject = styled.div`
  max-width: 400px;
  height: 100%;
  padding: 16px;

  @media (prefers-reduced-motion: no-preference) {
    &:hover,
    &:focus-within {
      .project-inner {
        transform: translateY(-3px);
      }
    }
  }

  a {
    position: relative;
    z-index: 1;
  }

  .project-inner {
    box-shadow: 0 10px 30px -15px rgba(2, 12, 27, 0.7);
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    height: 100%;
    padding: 2rem 1.75rem;
    border-radius: 4px;
    background-color: #01012b;
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  a {
    position: relative;
    z-index: 1;
  }

  .project-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 35px;

    .folder {
      color: #05d9e8;
      svg {
        width: 32px;
        height: 32px;
      }
    }
  }
  .project-title {
    margin: 0 0 8px;
    font-size: 24px;

    a {
      position: static;

      &:before {
        content: "";
        display: block;
        position: absolute;
        z-index: 0;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }
    }
  }
  .project-description {
    font-size: 16px;
    display: inline-block;
    text-decoration: none;
    text-decoration-skip-ink: auto;
    position: relative;
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    color: #e4e2f3;
    &:hover,
    &:focus,
    &:active {
      color: #6afffe;
      outline: 0;
      &:after {
        width: 100%;
      }
      & > * {
        color: #6afffe !important;
        transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
      }
    }
    &:after {
      content: "";
      display: block;
      width: 0;
      height: 1px;
      position: relative;
      bottom: 0.37em;
      background-color: #6afffe;
      transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
      opacity: 0.5;
    }
  }
  .project-tech-list {
    display: flex;
    align-items: flex-end;
    flex-grow: 1;
    flex-wrap: wrap;
    padding: 0;
    margin: 20px 0 0 0;
    list-style: none;
    color: #05d9e8;

    li {
      font-size: 12px;
      line-height: 1.75;

      &:not(:last-of-type) {
        margin-right: 15px;
      }
    }
  }
`

const Blog = ({ id, title, image, date, category, slug, desc }) => {
  return (
    <StyledProject>
      <Link to={`/blogs/${slug}`} key={id} className="project-inner">
        <header>
          <div className="project-top">
            <div className="folder">
              <Icon name="Folder" />
            </div>
          </div>
          <h3 className="project-title">{title}</h3>

          <br></br>
          <div className="project-description">{desc}</div>
        </header>
        <footer>
          <ul className="project-tech-list">
            <li>{date}</li>
          </ul>
        </footer>
      </Link>
    </StyledProject>
  )
}

export default Blog
